import { Component, Input, Output, EventEmitter, inject, Inject } from '@angular/core';
import { Api } from '../../services/api';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
  selector: 'app-mdl-change-owner',
  imports: [FormsModule,NgSelectModule,CommonModule],
  templateUrl: './mdl-change-owner.html',
  styleUrls: ['./mdl-change-owner.css']
})
export class MdlChangeOwnerComponent {
  users: any[] = [];
  selectedOwner: string = '';
  sendEmail: boolean = false;

  public prospectData: any;
   @Output() ownerChanged = new EventEmitter<any>();

    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private mdl: MatDialogRef<MdlChangeOwnerComponent>,
      private api: Api,
      
    ) {
    console.log('Datos recibidos en el modal:', data);
       this.prospectData = data.prospectData;
       console.log('ProspectData completo en modal:', this.prospectData);
       console.log('Prospecto ID:', this.prospectData.prospecto_id);


    this.api.getUsers().subscribe({
      next: (res: any) => {
        console.log('Respuesta de getUsers:', res.users);
        this.users = res.users || [];

        this.users = (res.users || []).map((user: any) => ({
          ...user,
          nombreCompleto: `${user.nombre} ${user.apellido}`,
        }),);

        for (let i = 0; i < this.users.length; i++) {
          if(this.users[i].usuario_id === this.prospectData.ejecutivo_id){
            this.selectedOwner = this.users[i].usuario_id;
          }
        }
      },
      error: (err) => {
        console.log('Error al cargar usuarios:', err);
        this.users = [];
      }
    });
  }

  get nombreCompletoseleccionado(): string {
    const user = this.users.find(u => u.usuario_id === this.prospectData.ejecutivo_id);
    return user ? `${user.nombre} ${user.apellido}` : '';
  }

  saveChange(): void {
    console.log('Selected Owner:', this.selectedOwner);
    console.log('Prospecto ID:', this.prospectData?.prospecto_id);

    if (!this.selectedOwner || !this.prospectData?.prospecto_id) {
      console.warn('Datos incompletos para guardar cambio de propietario');
      return;
    }

    const payload = {
      prospecto_id: this.prospectData.prospecto_id,
      newOwner: this.selectedOwner,
      notifyByEmail: this.sendEmail || false
    };
    console.log('Payload enviado:', this.prospectData);

    this.api.changeProspectOwner(payload).subscribe({
      next: (res) => {
        console.log('Respuesta cambio propietario:', res);
        window.alert('Propietario cambiado exitosamente');
        this.ownerChanged.emit(res);
        this.mdl.close(res);
      },
      error: (err) => {
        console.error('Error cambio propietario:', err);
        window.alert('Hubo un error al cambiar el propietario');
        this.mdl.close();
      }
    });
  }
  
  closeMdl(): void {
    this.mdl.close();
  }
}
